import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import NoFilter from "../../../../DataTable/datatable.nofilter";

export function URLColumn() {
    return {
        Header: 'URL',
        accessor: 'max',
        Filter: NoFilter,
        Cell: ({ row, value }: any) => {
            if (row.original.upperReleaseLimit != null) {
                return (
                    <OverlayTrigger overlay={<Tooltip>Sales limit: {value}</Tooltip>}>
                        <span>{row.original.upperReleaseLimit}</span>
                    </OverlayTrigger>
                );
            } else {
                return value;
            }
        }
    };
}
